import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { FileIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/payment-management/store-payment-log')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="paymentManagement.storePaymentLogs.crumb.storePaymentLogs" icon={FileIcon} />,
      title: <Translation id="paymentManagement.storePaymentLogs.crumb.storePaymentLogs" />,
    };
  },
  errorComponent: ({ error }) => {
    return <div>{error.message}</div>;
  },
});

function RouteComponent() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
